
















































import Vue from 'vue'
import {
  GlobalHeader as GlobalHeaderModule,
  SearchCategoryItem,
  CurrentUser,
  AccountNavItem,
  AccountMenuItem,
  ServiceNavItem,
  ServiceNavBasicItem,
  CartMenuItem
} from '@raksul/kamii-vue'
import ProductMenu from '@/common/components/globalHeader/ProductMenu.vue'
import ProductMenuMobile from '@/common/components/globalHeader/ProductMenuMobile.vue'
import SearchBoxMobile from '@/common/components/globalHeader/SearchBoxMobile.vue'
import { BrandModel } from '@/common/types/brands'
import { CommonAppData } from '@/common/types/commonAppData'
import { APP_PATH_REGEX } from '@/common/constants'
import { getBrandsData } from '@/common/service/index'
import { SEARCH_TRACKING_QUERY } from '@/common/utils/eventTracker'

import {
  searchCategoryItem,
  accountNavItems,
  accountMenuItems,
  serviceNavItems,
  mobileServiceNavBasicItems,
  desktopServiceNavBasicItems
} from '@/common/components/globalHeader/data'

export default Vue.extend({
  components: {
    GlobalHeaderModule,
    ProductMenu,
    ProductMenuMobile,
    SearchBoxMobile
  },
  props: {
    isDesktop: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object as () => CurrentUser,
      default: undefined
    },
    applicationData: {
      type: Object as () => CommonAppData,
      required: true
    }
  },
  data(): {
    loadingMenuData: boolean
    isSearchView: boolean
    brands: readonly BrandModel[]
    keyword: string
    isProductMenuVisible: boolean
  } {
    return {
      loadingMenuData: false,
      isSearchView: false,
      brands: [],
      keyword: '',
      isProductMenuVisible: false
    }
  },
  computed: {
    apparelKeyColor(): string {
      return '#ED7042'
    },
    currentProtocol(): string {
      return window.location.protocol
    },
    raksulBaseHost(): string {
      // refer to https://github.com/raksul/kamii-vue/blob/47b8f98ce2a327686d02bc4cd93a0734246cd1dd/src/components/GlobalHeader.vue#L595-L605
      return (this.applicationData.raksulCoreUrl.match(/(?:https:\/\/|http:\/\/)(.+)/) || [])[1] || 'raksul.com'
    },
    apparelAppUrl(): string {
      return `${this.currentProtocol}//${window.location.host}`
    },
    searchCategoryItems(): SearchCategoryItem[] {
      return [
        {
          label: 'アパレル・ユニフォーム',
          value: 'アパレル・ユニフォーム',
          url: `/search?${SEARCH_TRACKING_QUERY}=true&keyword=`,
          target: '_self',
          includeCategoryQuery: false
        },
        ...searchCategoryItem
      ]
    },
    accountNavItems(): AccountNavItem[] {
      return accountNavItems
    },
    accountMenuItems(): AccountMenuItem[] {
      return [...accountMenuItems(`${this.applicationData.raksulCoreUrl}`)]
    },
    serviceNavItems(): ServiceNavItem[] {
      return serviceNavItems.map(item => ({
        ...item,
        current: item.url === window.location.pathname
      })).filter(item => item.url !== '/catalog' || this.applicationData.isCorporateUser)
    },
    serviceNavBasicItems(): ServiceNavBasicItem[] {
      return this.isDesktop
        ? desktopServiceNavBasicItems
        : mobileServiceNavBasicItems
    },
    cartMenuItem(): CartMenuItem {
      return {
        url: '/cart',
        badgeCount: this.applicationData.cartCount
      }
    }
  },
  created() {
    const currentPath = window.location.pathname
    const { CATEGORY, SEARCH } = APP_PATH_REGEX
    this.isSearchView = CATEGORY.test(currentPath) || SEARCH.test(currentPath)
    if (this.isSearchView) {
      const parsedUrl = new URL(window.location.href)
      const keywordQuery = parsedUrl.searchParams.get('keyword') || ''
      this.keyword = keywordQuery
    }
  },
  methods: {
    signIn(): void {
      window.location.href = '/login'
    },
    signOut(): void {
      window.location.href = '/logout'
    },
    async fetchMenuData() {
      if (this.loadingMenuData) return
      this.loadingMenuData = true
      this.brands = await getBrandsData().finally(() => {
        this.loadingMenuData = false
      })
    }
  }
})
